import React from "react";

class Working extends React.Component {
  render() {
    return (
      <div className="App">
        <div className="work-section section pb-100 pb-lg-80 pb-md-60 pb-sm-40 pb-xs-30">
          <div className="container">
            <div className="section-header">
              <h2 className="section-title">How it Works?</h2>
              <p>
                With our simplified enrolment process find your best suitable
                skill
              </p>
            </div>
            <div className="row">
              <div className="col-lg-4 col-md-6">
                <div className="single-work">
                  <div className="work-image">
                    <span className="step">01</span>
                    <img src="/assets/img/icon_register_user.png" alt="" />
                  </div>
                  <div className="work-content">
                    <h3 className="title">
                      <a href="#">Register an account</a>
                    </h3>
                    <p>
                      Are you new to betel? <br /> Just register and find the
                      one that’s right for you.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="single-work">
                  <div className="work-image">
                    <span className="step">02</span>
                    <img src="/assets/img/icon_search_job.png" alt="" />
                  </div>
                  <div className="work-content">
                    <h3 className="title">
                      <a href="#">Search your job</a>
                    </h3>
                    <p>
                      If you are aiming at quality job that’s fit for you then
                      you are on right search track. Keep eyeing.
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6">
                <div className="single-work">
                  <div className="work-image">
                    <span className="step">03</span>
                    <img src="/assets/img/icon_apply.png" alt="" />
                  </div>
                  <div className="work-content">
                    <h3 className="title">
                      <a href="#">Apply for job</a>
                    </h3>
                    <p>
                      Save time and effort in your hiring journey. Just upload
                      your resume and you’re one step ahead to get your dream
                      job.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Working;
